import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { TB_PILOT_STATUS } from '../constants/EarlyRequesterNames';
const ENDPOINT = 'eligibility-engine/v2/eligibility/individual/portal-in-tb-pilot';
export const getPortalIsInTBPilot = () => {
  const earlyRequest = getEarlyRequesterResult(TB_PILOT_STATUS);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};